import React, { useEffect, useState } from "react";

const ServiceFilter = ( { services, selectedService, onServiceChange } ) => {

    return (
        <div className="clinic-finder__filters">

            <label className="clinic-finder__filter">
                <input checked={!selectedService ? 'selected' : false} id="all-services" name="clinic-finder-service" type="radio" value='' onChange={() => onServiceChange(null)}/>
                <span>All Clinics</span>
            </label>

            {services && Object.keys(services).map((service,index) => (
                <label className="clinic-finder__filter" key={index}>
                    <input checked={ selectedService == service ? 'selected' : false} id={service} name="clinic-finder-service" type="radio" value={service} onChange={() => onServiceChange(service)}/>
                    <span>{services[service]}</span>
                </label>
            ))}


        </div>
    )
};

export default ServiceFilter;